/**
 * NOLAS 2026, application multi evenement e.labriquerie.net.
 * src/i18n/fr.sondages.ts
 *
 * Messages ajoutés au module de sondages le 2026-10-05 : lien « Donner mon
 * avis » de la page « Plus », message quand aucun questionnaire n'est
 * ouvert, grille de notes (type matrix), conditions d'affichage et ciblage
 * par exclusion dans le back-office. Fusionné dans fr.ts.
 *
 * Plateforme multi-événements : aucun nom d'événement ni « salon »,
 * « atelier », « exposant » écrits en dur ; le type d'événement passe par
 * les jetons {eventType...}. Apostrophe typographique partout (en ICU,
 * l'apostrophe droite échappe l'accolade qui la suit).
 *
 * Mikael - chef de projet - 2026-10-05
 */
export const messagesSondagesFr: Record<string, string> = {
  // ── Page « Plus » ──────────────────────────────────────────────────────
  'sondages.plus.lien': 'Donner mon avis',

  // ── Page /sondages, aucun questionnaire ouvert ─────────────────────────
  'sondages.vide.titre': 'Aucun questionnaire n’est ouvert pour vous en ce moment.',
  'sondages.vide.texte':
    'Les questionnaires de satisfaction ouvrent le jour {eventTypeOf} : revenez sur cette page à ce moment-là, depuis « Plus » puis « Donner mon avis ».',

  // ── Grille de notes, côté participant ──────────────────────────────────
  'sondages.grille.borne': '{note} = {libelle}',
  'sondages.grille.note': '{note} sur {max}',

  // ── Back-office : grille de notes ──────────────────────────────────────
  'surveys.qtype.matrix': 'Grille de notes',
  'sondages.admin.grille.lignes': 'Critères notés',
  'sondages.admin.grille.ligne': 'Critère {n}',
  'sondages.admin.grille.ajouter': '+ Ajouter un critère',
  'sondages.admin.grille.monter': 'Monter le critère {n}',
  'sondages.admin.grille.descendre': 'Descendre le critère {n}',
  'sondages.admin.grille.supprimer': 'Supprimer le critère {n}',
  'sondages.admin.grille.min': 'Note minimale',
  'sondages.admin.grille.max': 'Note maximale',
  'sondages.admin.grille.minLibelle': 'Sens de la note minimale',
  'sondages.admin.grille.maxLibelle': 'Sens de la note maximale',
  'sondages.admin.echelle.min': 'Échelle : de',
  'sondages.admin.echelle.max': 'à',

  // ── Back-office : condition d'affichage ────────────────────────────────
  'sondages.admin.condition.titre': 'Condition d’affichage',
  'sondages.admin.condition.source': 'Afficher seulement si la question',
  'sondages.admin.condition.aucune': 'Toujours afficher',
  'sondages.admin.condition.valeurs': 'a pour réponse (au moins une) :',
  'sondages.admin.condition.sansSource':
    'Aucune question précédente à choix (choix unique, choix multiple ou oui / non) : condition impossible ici.',

  // ── Back-office : ciblage par exclusion ────────────────────────────────
  'sondages.admin.rolesExclus': 'Rôles exclus (séparés par des virgules)',
  'sondages.admin.rolesExclus.aide':
    'Toutes les personnes ciblées SAUF ces rôles. Exemple : exhibitor, plastron.',

  // ── Back-office : refus du serveur ─────────────────────────────────────
  'sondages.admin.erreur.grille':
    'Grille incomplète : au moins un critère, et une note minimale inférieure à la note maximale (de 0 à 10).',
  'sondages.admin.erreur.condition':
    'Condition d’affichage incohérente : la question source doit précéder et proposer les valeurs choisies.',

  // ── Back-office : restitution de la grille ─────────────────────────────
  'sondages.admin.resultats.ligne': '{ligne} : moyenne {moyenne} ({n, plural, one {# note} other {# notes}})',

  // 2026-10-05 : aperçu au back-office, et cible et ouverture dans la liste.
  // Mikael - chef de projet - 2026-10-05
  'sondages.apercu.bouton': 'Aperçu',
  'sondages.apercu.titre': 'Aperçu : {title}',
  'sondages.apercu.comme': 'Voir comme',
  'sondages.apercu.comme.exhibitor': '{lexExhibitorCap}',
  'sondages.apercu.comme.visitor': '{lexVisitorCap}',
  'sondages.apercu.cible.oui.exhibitor': 'Ce sondage s’affichera pour {lexExhibitorIndef}.',
  'sondages.apercu.cible.non.exhibitor': 'Ce sondage NE s’affichera PAS pour {lexExhibitorIndef} : son ciblage l’exclut.',
  'sondages.apercu.cible.oui.visitor': 'Ce sondage s’affichera pour {lexVisitorIndef}.',
  'sondages.apercu.cible.non.visitor': 'Ce sondage NE s’affichera PAS pour {lexVisitorIndef} : son ciblage l’exclut.',
  'sondages.apercu.nonPublie': 'Il n’est pas encore publié : personne ne le voit pour l’instant.',
  'sondages.apercu.erreur': 'L’aperçu n’a pas pu être chargé.',
  'sondages.apercu.rienEnregistre': 'Aperçu : les réponses saisies ici ne sont pas enregistrées.',
  'sondages.liste.pour': 'Pour : {cible}',
  'sondages.liste.pour.tous': 'tout le monde',
  'sondages.liste.pour.sauf': 'tout le monde sauf {roles}',
  'sondages.liste.pour.filtre': 'un public filtré (voir le ciblage)',
  'sondages.liste.ouvre': 'Ouvre le {date}',
  'sondages.liste.ferme': 'jusqu’au {date}',
  'sondages.liste.phase': 'Ouvert : {phase}',
};
